import styles from './Breadcrumbs.module.scss';
import React from 'react';
import { Ssvg } from '../../../../Components/react/Ssvg';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../../../constants/searchParamKeys';
import { clsx } from '../../../../utils/clsx';
import { useDynamicConfigs } from '../../../hooks/useDynamicConfigs';
const Separator = () => (React.createElement("li", { "aria-hidden": "true", className: clsx('d:flex ai:center', styles.separator) },
    React.createElement(Ssvg, { icon: "#icon--arrow-breadcrumb", className: styles.icon })));
const CollectionSteps = () => {
    const { collection, hierarchyObjects } = useDynamicConfigs();
    const { handle, medium } = useParams();
    const [searchParams] = useSearchParams();
    const collectionObj = hierarchyObjects?.[handle];
    if (hierarchyObjects === undefined || collectionObj === undefined) {
        return React.createElement(React.Fragment, null,
            React.createElement(Separator, null),
            React.createElement("li", null,
                React.createElement("span", { className: styles.item }, collection?.title ?? 'Search')));
    }
    searchParams.delete(SEARCH_PARAM_KEY_PAGE_NUMBER);
    const searchParamsStr = searchParams.toString();
    return React.createElement(React.Fragment, null, collectionObj.pathToCurrent.map(({ name, handle }, i) => {
        const label = hierarchyObjects[handle]?.name ?? name;
        return React.createElement(React.Fragment, { key: label },
            React.createElement(Separator, null),
            React.createElement("li", null, i + 1 === collectionObj.pathToCurrent.length
                ? React.createElement("span", { className: styles.item }, label)
                : React.createElement(Link, { to: { pathname: `/collections/${handle}${medium !== undefined ? `/${medium}` : ''}`, ...(searchParamsStr.length > 0 && { search: `?${searchParamsStr}` }) }, className: styles.item }, label)));
    }));
};
export const Breadcrumbs = () => {
    const { handle } = useParams();
    const { customBreadcrumbSteps } = useDynamicConfigs();
    return (React.createElement("nav", { className: styles.container, "aria-label": "breadcrumb" },
        React.createElement("ol", { className: "list:none text:uppercase d:flex fxw:wrap ai:center" },
            React.createElement("li", null,
                React.createElement("a", { href: "/", className: styles.item }, "Home")),
            customBreadcrumbSteps?.map(({ url, title }) => {
                return React.createElement(React.Fragment, { key: title },
                    React.createElement(Separator, null),
                    React.createElement("li", null,
                        React.createElement("a", { href: url, className: styles.item }, title)));
            }),
            handle !== undefined && React.createElement(CollectionSteps, null))));
};
